import { render } from "./LeftCol.vue?vue&type=template&id=04545c0c&ts=true"
import script from "./LeftCol.vue?vue&type=script&lang=ts"
export * from "./LeftCol.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vaab/dev/js/monujo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__